module.exports = __webpack_public_path__ + "img/vertical_4_6_8004.5fc5a1c3.png";